import {
  getModule,
  Module,
  VuexModule,
  //   Mutation,
  MutationAction,
} from "vuex-module-decorators";
import store from "@/store";
import { PolylineLoc } from "@/store/common/model/init";

@Module({
  namespaced: true,
  name: "init",
  store,
  dynamic: true,
})
class InitModule extends VuexModule {
  urlParam: string | null = null;

  @MutationAction
  async getUrlParameter(sParam) {
    const sPageURL = decodeURIComponent(window.location.search.substring(1)),
      sURLVariables = sPageURL.split("&");
    let i, sParameterName;
    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split("=");

      if (sParameterName[0] === sParam) {
        this.urlParam =
          sParameterName[1] === undefined ? null : sParameterName[1];
        break;
      }
    }
    return { urlParam: this.urlParam };
  }

  roundOffToTwoDecimal(num) {
    return Math.round(num * 100) / 100;
  }

  decodePolyline(encoded) {
    if (encoded == null || encoded.length == 0) return null;

    let polylineStartTime;
    const withSpeed = encoded.startsWith("AAB");
    if (encoded.startsWith("AAA") || encoded.startsWith("AAB")) {
      polylineStartTime = parseInt(
        encoded.substring(3, encoded.indexOf("==="))
      );
      encoded = encoded.substring(encoded.indexOf("===") + 3);
    }

    // array that holds the points

    const points = [] as PolylineLoc[];
    let index = 0;
    const len = encoded.length;
    let lat = 0,
      lng = 0;
    let tym = 0;
    let speed;
    while (index < len) {
      let b,
        shift = 0,
        result = 0;
      do {
        b = encoded.charAt(index++).charCodeAt(0) - 63; //finds ascii                                                                                    //and substract it by 63
        result |= (b & 0x1f) << shift;
        shift += 5;
      } while (b >= 0x20);

      const dlat = (result & 1) != 0 ? ~(result >> 1) : result >> 1;
      lat += dlat;

      if (index === len) break;

      shift = 0;
      result = 0;
      do {
        b = encoded.charAt(index++).charCodeAt(0) - 63;
        result |= (b & 0x1f) << shift;
        shift += 5;
      } while (b >= 0x20);

      const dlng = (result & 1) != 0 ? ~(result >> 1) : result >> 1;
      lng += dlng;

      if (polylineStartTime != null) {
        shift = result = 0;
        do {
          b = encoded.charAt(index++).charCodeAt(0) - 63;
          result |= (b & 0x1f) << shift;
          shift += 5;
        } while (b >= 0x20);
        const dtym = (result & 1) != 0 ? ~(result >> 1) : result >> 1;
        tym = dtym;
      }

      if (withSpeed != null) {
        shift = result = 0;
        do {
          b = encoded.charAt(index++).charCodeAt(0) - 63;
          result |= (b & 0x1f) << shift;
          shift += 5;
        } while (b >= 0x20);
        const dtym = (result & 1) != 0 ? ~(result >> 1) : result >> 1;
        speed = dtym;
      }

      const polylineLoc = {} as PolylineLoc;
      polylineLoc.lat = lat / 1e5;
      polylineLoc.lng = lng / 1e5;
      if (polylineStartTime != null) {
        polylineLoc.time = polylineStartTime + tym;
        if (speed != null && speed != -1) {
          polylineLoc.speed = speed * 3.6;
        }
      }

      points.push(polylineLoc);
    }
    return points;
  }
}

export default getModule(InitModule);
